export enum UnitDisplayEnum {
  NO_DISPLAY = 'NO_DISPLAY',
  DEGREE = 'DEGREE',
  UNIT = 'UNIT',
  DEGREE_UNIT = 'DEGREE_UNIT',
}
